import countries from 'constants/countries';

export default function getCountryNameByIsoCode(isoCode) {
  if (!isoCode) {
    return isoCode;
  }
  const item = countries.find(x => x.value.toLowerCase() === isoCode.toLowerCase());
  return (item && item.label) || isoCode;
}
